module.exports = __webpack_public_path__ + "img/2_11.777e1c93.png";